<template>
  <div class="main-wrapper">
    <table>
      <tr>
        <td class="left-column">
          <p>Полное наименование</p>
        </td>
        <td>
          <input
            type="text"
            class="input-line"
            v-model="pageInfo.ORG_FULL_NAME"
            :disabled="true"
          />
        </td>
      </tr>
      <!-- <tr>
        <td class="left-column">
          <p>Статус ИП</p>
        </td>
        <td>
          <input
            type="text"
            class="input-line"
            v-model="pageInfo.STATUS_STRING"
            :disabled="true"
          />
        </td>
      </tr> -->
      <tr>
        <td class="left-column">
          <p class="necessary-bold">
            <span
              :class="
                sendData.REG_ADDRESS != null && sendData.REG_ADDRESS.length == 0
                  ? 'unvalid-field'
                  : 'valid-field'
              "
              >➤</span
            >
            Адрес места жительства (регистрации)
          </p>
        </td>
        <td>
          <textarea
            class="textarea-input"
            cols="65"
            v-model="sendData.REG_ADDRESS"
            @input="
              isUpdate = true;
              sendData.REG_ADDRESS != null && sendData.REG_ADDRESS.length > 1000
                ? (sendData.REG_ADDRESS = sendData.REG_ADDRESS.substr(0, 1000))
                : sendData.REG_ADDRESS;
            "
            :disabled="
              pageInfo.DISABLED != null &&
                pageInfo.DISABLED.indexOf('REG_ADDRESS') != -1
            "
          ></textarea>
        </td>
      </tr>
      <tr>
        <td class="left-column">
          <p class="necessary-bold">
            <span
              :class="
                sendData.FACT_ADDRESS != null &&
                sendData.FACT_ADDRESS.length == 0 &&
                !actualAddressLikeLegal
                  ? 'unvalid-field'
                  : 'valid-field'
              "
              >➤</span
            >
            Адрес места пребывания
          </p>
          <input
            type="checkbox"
            id="adressFact"
            v-model="actualAddressLikeLegal"
            :checked="
              actualAddressLikeLegal
                ? (sendData.FACT_ADDRESS = sendData.REG_ADDRESS)
                : sendData.FACT_ADDRESS
            "
            @click="
              isUpdate = true;
              sendData.FACT_ADDRESS = '';
              isUpdate = true;
            "
            :disabled="
              pageInfo.DISABLED != null &&
                pageInfo.DISABLED.indexOf('FACT_ADDRESS') != -1
            "
          />
          <label for="adressFact">Cовпадает с адресом места жительства</label>
        </td>
        <td>
          <textarea
            class="textarea-input"
            cols="65"
            v-model="sendData.FACT_ADDRESS"
            :disabled="
              actualAddressLikeLegal ||
                (pageInfo.DISABLED != null &&
                  pageInfo.DISABLED.indexOf('FACT_ADDRESS') != -1)
            "
            @input="
              isUpdate = true;
              sendData.FACT_ADDRESS != null &&
              sendData.FACT_ADDRESS.length > 1000
                ? (sendData.FACT_ADDRESS = sendData.FACT_ADDRESS.substr(
                    0,
                    1000
                  ))
                : sendData.FACT_ADDRESS;
            "
          ></textarea>
        </td>
      </tr>
      <tr>
        <td class="left-column">
          <p class="necessary-bold">
            <span
              :class="
                sendData.POST_ADDRESS != null &&
                sendData.POST_ADDRESS.length == 0 &&
                !mailAddressLikeActual &&
                !mailAddressLikeLegal
                  ? 'unvalid-field'
                  : 'valid-field'
              "
              >➤</span
            >
            Почтовый адрес
          </p>
          <div class="checkboxes">
            <label>
              <input
                type="checkbox"
                id="mailUrid"
                v-model="mailAddressLikeLegal"
                :checked="
                  !mailAddressLikeActual && mailAddressLikeLegal
                    ? (sendData.POST_ADDRESS = sendData.REG_ADDRESS)
                    : sendData.POST_ADDRESS
                "
                @click="
                  sendData.POST_ADDRESS = '';
                  mailAddressLikeActual = false;
                  isUpdate = true;
                "
                :disabled="
                  pageInfo.DISABLED != null &&
                    pageInfo.DISABLED.indexOf('POST_ADDRESS') != -1
                "
              />Cовпадает с адресом места жительства
            </label>

            <label>
              <input
                type="checkbox"
                id="mailFact"
                v-model="mailAddressLikeActual"
                :checked="
                  mailAddressLikeActual && !mailAddressLikeLegal
                    ? (sendData.POST_ADDRESS = sendData.FACT_ADDRESS)
                    : sendData.POST_ADDRESS
                "
                @click="
                  sendData.POST_ADDRESS = '';
                  mailAddressLikeLegal = false;
                  isUpdate = true;
                "
                :disabled="
                  pageInfo.DISABLED != null &&
                    pageInfo.DISABLED.indexOf('POST_ADDRESS') != -1
                "
              />Cовпадает с адресом места пребывания
            </label>
          </div>
        </td>
        <td>
          <textarea
            class="textarea-input"
            cols="65"
            v-model="sendData.POST_ADDRESS"
            :disabled="
              mailAddressLikeActual ||
                mailAddressLikeLegal ||
                (pageInfo.DISABLED != null &&
                  pageInfo.DISABLED.indexOf('POST_ADDRESS') != -1)
            "
          ></textarea>
        </td>
      </tr>
      <tr>
        <td class="left-column">
          <p class="necessary-bold">
            <span
              :class="
                (sendData.EMAIL != null && sendData.EMAIL.length == 0) ||
                unvalidEmail
                  ? 'unvalid-field'
                  : 'valid-field'
              "
              >➤</span
            >
            Адрес электронной почты
          </p>
        </td>
        <td>
          <input
            type="text"
            v-model="sendData.EMAIL"
            v-bind:class="
              unvalidEmail ? 'necessary-unvalid' : 'necessary-valid'
            "
            placeholder="example@mail.com"
            @blur="checkEmail()"
            @input="
              isUpdate = true;
              sendData.EMAIL != null && sendData.EMAIL.length > 100
                ? (sendData.EMAIL = sendData.EMAIL.substr(0, 100))
                : sendData.EMAIL;
            "
            :disabled="
              pageInfo.DISABLED != null &&
                pageInfo.DISABLED.indexOf('EMAIL') != -1
            "
          />
          <p class="necessary-message" v-if="unvalidEmail">
            Введите корректный адрес электронной почты
          </p>
        </td>
      </tr>
      <tr>
        <td class="left-column">
          <p class="necessary-bold">
            <span
              :class="
                sendData.AUX_EMAIL == null || !unvalidAuxEmail
                  ? 'valid-field'
                  : 'unvalid-field'
              "
              >➤</span
            >
            Адрес электронной почты (дополнительный)
          </p>
          <p></p>
        </td>
        <td>
          <input
            type="text"
            v-model="sendData.AUX_EMAIL"
            v-bind:class="
              unvalidEmail ? 'necessary-unvalid' : 'necessary-valid'
            "
            placeholder="example@mail.com"
            @blur="checkAuxEmail()"
            @input="
              isUpdate = true;
              sendData.AUX_EMAIL != null && sendData.AUX_EMAIL.length > 100
                ? (sendData.AUX_EMAIL = sendData.AUX_EMAIL.substr(0, 100))
                : sendData.AUX_EMAIL;
            "
            :disabled="
              pageInfo.DISABLED != null &&
                pageInfo.DISABLED.indexOf('AUX_EMAIL') != -1
            "
          />
          <p class="necessary-message" v-if="unvalidAuxEmail">
            Введите корректный адрес электронной почты
          </p>
        </td>
      </tr>
      <tr>
        <td class="left-column">
          <p class="necessary-bold">
            <span
              :class="
                (!haveSite &&
                  sendData.WEB_SITE != null &&
                  sendData.WEB_SITE.length == 0) ||
                unvalidSite
                  ? 'unvalid-field'
                  : 'valid-field'
              "
              >➤</span
            >
            Сайт
          </p>
          <input
            type="checkbox"
            v-model="haveSite"
            id="checkboxSite"
            @click="
              siteChecked();
              isUpdate = true;
            "
            :disabled="
              pageInfo.DISABLED != null &&
                pageInfo.DISABLED.indexOf('WEB_SITE') != -1
            "
          />
          <label for="checkboxSite">Сайт отсутствует</label>
        </td>
        <td>
          <input
            type="text"
            v-bind:class="unvalidSite ? 'necessary-unvalid' : 'necessary-valid'"
            v-model="sendData.WEB_SITE"
            :disabled="
              haveSite ||
                (pageInfo.DISABLED != null &&
                  pageInfo.DISABLED.indexOf('WEB_SITE') != -1)
            "
            @blur="checkSite()"
            @input="
              isUpdate = true;
              sendData.WEB_SITE != null && sendData.WEB_SITE.length > 80
                ? (sendData.WEB_SITE = sendData.WEB_SITE.substr(0, 80))
                : sendData.WEB_SITE;
            "
          />
          <p class="necessary-message" v-if="unvalidSite">
            Введите корректный адрес сайта
          </p>
        </td>
      </tr>
      <tr>
        <td class="left-column">
          <p class="necessary-bold">
            <span
              :class="
                !unvalidAuxSite || haveSite ? 'valid-field' : 'unvalid-field'
              "
              >➤</span
            >
            Сайт (дополнительный)
          </p>
        </td>
        <td>
          <input
            type="text"
            v-bind:class="
              unvalidAuxSite ? 'necessary-unvalid' : 'necessary-valid'
            "
            v-model="sendData.AUX_WEB_SITE"
            :disabled="
              haveSite ||
                (pageInfo.DISABLED != null &&
                  pageInfo.DISABLED.indexOf('WEB_SITE') != -1)
            "
            @blur="checkAuxSite()"
            @input="
              isUpdate = true;
              sendData.AUX_WEB_SITE != null && sendData.AUX_WEB_SITE.length > 80
                ? (sendData.AUX_WEB_SITE = sendData.AUX_WEB_SITE.substr(0, 80))
                : sendData.AUX_WEB_SITE;
            "
          />
          <p class="necessary-message" v-if="unvalidAuxSite">
            Введите корректный адрес сайта
          </p>
        </td>
      </tr>
      <tr>
        <td>
          <p>
            <span
              :class="
                sendData.PHONE_NUMBER != null &&
                sendData.PHONE_NUMBER.length != 18
                  ? 'unvalid-field'
                  : 'valid-field'
              "
              >➤</span
            >
            Телефон
          </p>
        </td>
        <td class="row">
          <input
            type="text"
            v-mask="'+7 (###) ###-##-##'"
            class="telephone-lines"
            v-model="sendData.PHONE_NUMBER"
            @input="isUpdate = true"
            placeholder="+7 (###) ###-##-##"
            :disabled="
              pageInfo.DISABLED != null &&
                pageInfo.DISABLED.indexOf('PHONE_NUMBER') != -1
            "
          />
          <input
            type="text"
            v-mask="'########'"
            class="telephone-lines"
            v-model="sendData.PHONE_APPEND"
            @input="isUpdate = true"
            placeholder="доб. номер (если есть)"
            :disabled="
              pageInfo.DISABLED != null &&
                pageInfo.DISABLED.indexOf('PHONE_APPEND') != -1
            "
          />
        </td>
      </tr>
      <tr>
        <td>
          <p>
            <span
              :class="
                (sendData.AUX_PHONE_NUMBER != null &&
                  (sendData.AUX_PHONE_NUMBER.length == 18 ||
                    sendData.AUX_PHONE_NUMBER.length == 0)) ||
                sendData.AUX_PHONE_NUMBER == null
                  ? 'valid-field'
                  : 'unvalid-field'
              "
              >➤</span
            >
            Телефон (дополнительный)
          </p>
        </td>
        <td>
          <input
            type="text"
            v-mask="'+7 (###) ###-##-##'"
            class="telephone-lines"
            v-model="sendData.AUX_PHONE_NUMBER"
            @input="isUpdate = true"
            placeholder="+7 (###) ###-##-##"
            :disabled="
              pageInfo.DISABLED != null &&
                pageInfo.DISABLED.indexOf('AUX_PHONE_NUMBER') != -1
            "
          />
          <input
            type="text"
            v-mask="'########'"
            class="telephone-lines"
            v-model="sendData.AUX_PHONE_APPEND"
            @input="isUpdate = true"
            placeholder="доб. номер (если есть)"
            :disabled="
              pageInfo.DISABLED != null &&
                pageInfo.DISABLED.indexOf('AUX_PHONE_APPEND') != -1
            "
          />
        </td>
      </tr>
      <tr>
        <td class="left-column">
          <p>ОКФС</p>
        </td>
        <td>
          <input
            type="text"
            class="input-line"
            v-mask="'##'"
            v-model="pageInfo.OKFS"
            :disabled="true"
          />
        </td>
      </tr>
      <tr>
        <td class="left-column">
          <p>ОКПО</p>
        </td>
        <td>
          <input
            type="text"
            class="input-line"
            v-mask="'##########'"
            v-model="pageInfo.OKPO"
            :disabled="true"
          />
        </td>
      </tr>
      <tr>
        <td class="left-column">
          <p>ОКОПФ</p>
        </td>
        <td>
          <input
            type="text"
            class="input-line"
            v-mask="'#####'"
            v-model="pageInfo.OKOPF"
            :disabled="true"
          />
        </td>
      </tr>
      <tr>
        <td class="left-column">
          <p>ОКАТО</p>
        </td>
        <td>
          <input
            type="text"
            class="input-line"
            v-mask="'###########'"
            v-model="pageInfo.OKATO"
            :disabled="true"
          />
        </td>
      </tr>
      <tr>
        <td class="left-column">
          <p>ОКТМО</p>
        </td>
        <td>
          <input
            type="text"
            class="input-line"
            v-mask="'###########'"
            v-model="pageInfo.OKTMO"
            disabled
          />
        </td>
      </tr>
      <tr>
        <td class="left-column">
          <p>ОКОГУ</p>
        </td>
        <td>
          <input
            type="text"
            class="input-line"
            v-mask="'#######'"
            v-model="pageInfo.OKOGU"
            :disabled="true"
          />
        </td>
      </tr>
      <tr>
        <td class="left-column">
          <p>
            Среднесписочная численность (наличие наемных сотрудников)
          </p>
        </td>
        <td>
          <input
            type="text"
            class="input-line"
            v-model.lazy="stuffCount"
            v-money="money"
            :onchange="onChangeStuffCount()"
            :disabled="
              pageInfo.DISABLED != null &&
                pageInfo.DISABLED.indexOf('STUFF_COUNT') != -1
            "
          />
        </td>
      </tr>
      <tr>
        <td>
          <p class="necessary-bold">
            <span
              :class="
                sendData.TAX_STATUS != null ? 'valid-field' : 'unvalid-field'
              "
              >➤</span
            >
            Налоговый статус
          </p>
        </td>
        <td>
          <dropdown
            :options="taxesStatuses"
            :selected="{ name: sendData.TAX_STATUS }"
            placeholder="Выберите статус"
            v-on:updateOption="
              sendData.TAX_STATUS = $event.name;
              isUpdate = true;
              $forceUpdate();
            "
            :disabled="
              pageInfo.DISABLED != null &&
                pageInfo.DISABLED.indexOf('TAX_STATUS') != -1
            "
          ></dropdown>
        </td>
      </tr>
      <tr>
        <td>
          <p>СНИЛС</p>
        </td>
        <td>
          <input
            type="text"
            class="input-line"
            @input="isUpdate = true"
            v-model="sendData.SNILS"
            v-mask="'###-###-### ##'"
            :disabled="
              pageInfo.DISABLED != null &&
                pageInfo.DISABLED.indexOf('SNILS') != -1
            "
          />
        </td>
      </tr>
      <tr>
        <td>
          <p class="necessary-bold">
            <span
              :class="
                sendData.DUL_DOCTYPE != null ? 'valid-field' : 'unvalid-field'
              "
              >➤</span
            >
            Тип документа, удостоверяющего личность
          </p>
        </td>
        <td>
          <dropdown
            :options="docTypes"
            :selected="{ name: sendData.DUL_DOCTYPE }"
            v-on:updateOption="
              isUpdate = true;
              sendData.DUL_DOCTYPE = $event.name;
              $forceUpdate();
            "
            placeholder="Выберите тип удостоверяющего документа"
            :disabled="
              pageInfo.DISABLED != null &&
                pageInfo.DISABLED.indexOf('DUL_DOCTYPE') != -1
            "
          ></dropdown>
        </td>
      </tr>
      <tr>
        <td>
          <p class="necessary-bold">
            <span
              :class="
                sendData.DUL_SERIAL != null && sendData.DUL_SERIAL.length > 0
                  ? 'valid-field'
                  : 'unvalid-field'
              "
              >➤</span
            >
            Серия документа
          </p>
        </td>
        <td>
          <input
            type="text"
            class="input-line"
            v-model="sendData.DUL_SERIAL"
            :onchanged="
              sendData.DUL_SERIAL != null &&
              sendData.DUL_SERIAL != formatDocNumber(sendData.DUL_SERIAL)
                ? (sendData.DUL_SERIAL = formatDocNumber(sendData.DUL_SERIAL))
                : sendData.DUL_SERIAL
            "
            @input="isUpdate = true"
            :disabled="
              pageInfo.DISABLED != null &&
                pageInfo.DISABLED.indexOf('DUL_SERIAL') != -1
            "
          />
        </td>
      </tr>
      <tr>
        <td>
          <p class="necessary-bold">
            <span
              :class="
                sendData.DUL_NUMBER != null && sendData.DUL_NUMBER.length > 0
                  ? 'valid-field'
                  : 'unvalid-field'
              "
              >➤</span
            >
            Номер документа
          </p>
        </td>
        <td>
          <input
            type="text"
            class="input-line"
            v-model="sendData.DUL_NUMBER"
            :onchanged="
              sendData.DUL_NUMBER != null &&
              sendData.DUL_NUMBER != formatDocNumber(sendData.DUL_NUMBER)
                ? (sendData.DUL_NUMBER = formatDocNumber(sendData.DUL_NUMBER))
                : sendData.DUL_NUMBER
            "
            @input="isUpdate = true"
            :disabled="
              pageInfo.DISABLED != null &&
                pageInfo.DISABLED.indexOf('DUL_NUMBER') != -1
            "
          />
        </td>
      </tr>
      <tr>
        <td>
          <p class="necessary-bold">
            <span
              :class="
                sendData.DUL_DATE != null &&
                sendData.DUL_DATE.length == 10 &&
                !unvalidDulDate
                  ? 'valid-field'
                  : 'unvalid-field'
              "
              >➤</span
            >
            Дата выдачи документа
          </p>
        </td>
        <td>
          <input
            type="text"
            class="input-line"
            v-model="sendData.DUL_DATE"
            v-mask="'##.##.####'"
            placeholder="дд.мм.гггг"
            :onchanged="dulDateChanged()"
            @input="isUpdate = true"
            @blur="checkDulDate()"
            :disabled="
              pageInfo.DISABLED != null &&
                pageInfo.DISABLED.indexOf('DUL_DATE') != -1
            "
          />
          <p class="necessary-message" v-if="unvalidDulDate">
            Введите корректную дату выдачи документа
          </p>
        </td>
      </tr>
      <tr>
        <td>
          <p class="necessary-bold">
            <span
              :class="
                (sendData.DUL_CODE != null && sendData.DUL_CODE.length > 0) ||
                hasCode
                  ? 'valid-field'
                  : 'unvalid-field'
              "
              >➤</span
            >
            Код подразделения
          </p>
          <label>
            <input
              type="checkbox"
              v-model="hasCode"
              id="checkboxEnglishName"
              @click="
                sendData.DUL_CODE = '';
                isUpdate = true;
                issuerList = [];
                sendData.disableIssue = false;
              "
              :disabled="
                pageInfo.DISABLED != null &&
                  pageInfo.DISABLED.indexOf('DUL_CODE') != -1
              "
            />
            Код подразделения отсутствует
          </label>
        </td>
        <td>
          <input
            class="input-line"
            type="text"
            v-model="sendData.DUL_CODE"
            v-mask="'###-###'"
            :disabled="hasCode"
            :onchanged="
              sendData.DUL_CODE != null && sendData.DUL_CODE.length > 7
                ? (sendData.DUL_CODE = sendData.DUL_CODE.substr(0, 7))
                : sendData.DUL_CODE
            "
            @input="
              isUpdate = true;
              sendData.DUL_CODE.length == 7 &&
              sendData.disableIssue != null &&
              !sendData.disableIssue
                ? getDulIssue(sendData)
                : (sendData.disableIssue = false);
              issuerList = [];
            "
          />
        </td>
      </tr>
      <tr>
        <td>
          <p class="necessary-bold">
            <span
              :class="
                sendData.DUL_ISSUER != null &&
                sendData.DUL_ISSUER.length > 0 &&
                sendData.DUL_ISSUER != 'Подразделение не найдено'
                  ? 'valid-field'
                  : 'unvalid-field'
              "
              >➤</span
            >
            Наименование органа, выдавшего документ
          </p>
        </td>
        <td>
          <dropdown
            v-if="issuerList != null && issuerList.length > 1"
            :options="issuerList"
            :selected="{ name: 'Выберите наименование' }"
            v-on:updateOption="
              sendData.DUL_ISSUER = $event.name;
              isUpdate = true;
              $forceUpdate();
            "
            :disabled="
              pageInfo.DISABLED != null &&
                pageInfo.DISABLED.indexOf('DUL_ISSUER') != -1
            "
          ></dropdown>
          <input
            v-if="issuerList == null || issuerList.length <= 1"
            type="text"
            class="input-line"
            v-model="sendData.DUL_ISSUER"
            :onchanged="
              sendData.DUL_ISSUER != null && sendData.DUL_ISSUER.length > 80
                ? (sendData.DUL_ISSUER = sendData.DUL_ISSUER.substr(0, 80))
                : sendData.DUL_ISSUER
            "
            @input="isUpdate = true"
            :disabled="
              (sendData.disableIssue != null &&
                sendData.disableIssue &&
                !hasCode) ||
                (pageInfo.DISABLED != null &&
                  pageInfo.DISABLED.indexOf('DUL_ISSUER') != -1)
            "
            @focus="
              sendData.DUL_ISSUER == 'Подразделение не найдено'
                ? (sendData.DUL_ISSUER = '')
                : sendData.DUL_ISSUER
            "
          />
        </td>
      </tr>

      <tr>
        <td>
          <p class="necessary-bold">
            <span
              :class="
                sendData.BIRTH_DATE != null &&
                sendData.BIRTH_DATE.length == 10 &&
                !unvalidBirthDate
                  ? 'valid-field'
                  : 'unvalid-field'
              "
              >➤</span
            >
            Дата рождения
          </p>
        </td>
        <td>
          <input
            type="text"
            v-model="sendData.BIRTH_DATE"
            v-bind:class="
              unvalidBirthDate ? 'necessary-unvalid' : 'necessary-valid'
            "
            v-mask="'##.##.####'"
            placeholder="дд.мм.гггг"
            :onchanged="birthDateChanged()"
            @blur="checkBirthDate()"
            @input="isUpdate = true"
            :disabled="
              pageInfo.DISABLED != null &&
                pageInfo.DISABLED.indexOf('BIRTH_DATE') != -1
            "
          />
          <p class="necessary-message" v-if="unvalidBirthDate">
            Возраст должен быть не менее 14 лет
          </p>
        </td>
      </tr>
      <tr>
        <td>
          <p class="necessary-bold">
            <span
              :class="
                sendData.BIRTH_PLACE != null && sendData.BIRTH_PLACE.length > 0
                  ? 'valid-field'
                  : 'unvalid-field'
              "
              >➤</span
            >
            Место рождения
          </p>
        </td>
        <td>
          <input
            class="input-line"
            type="text"
            v-model="sendData.BIRTH_PLACE"
            @input="isUpdate = true"
            :disabled="
              pageInfo.DISABLED != null &&
                pageInfo.DISABLED.indexOf('BIRTH_PLACE') != -1
            "
          />
        </td>
      </tr>
      <tr>
        <td>
          <p class="necessary-bold">
            <span
              :class="
                sendData.CITIZENSHIP != null && sendData.CITIZENSHIP.length > 0
                  ? 'valid-field'
                  : 'unvalid-field'
              "
              >➤</span
            >
            Гражданство (подданство) (указываются все страны, в которых
            физическое лицо имеет гражданство)
          </p>
        </td>
        <td>
          <input
            type="text"
            class="input-line"
            v-model="sendData.CITIZENSHIP"
            :onchanged="
              sendData.CITIZENSHIP != null && sendData.CITIZENSHIP.length > 80
                ? (sendData.CITIZENSHIP = sendData.CITIZENSHIP.substr(0, 80))
                : sendData.CITIZENSHIP
            "
            @input="isUpdate = true"
            :disabled="
              pageInfo.DISABLED != null &&
                pageInfo.DISABLED.indexOf('CITIZENSHIP') != -1
            "
          />
        </td>
      </tr>
      <tr v-if="sendData.TAX_STATUS == 'Нерезидент'">
        <td>
          <p class="necessary-bold">
            <span
              :class="
                sendData.HAS_MIGRATION_CARD != null
                  ? 'valid-field'
                  : 'unvalid-field'
              "
              >➤</span
            >
            Наличие миграционной карты
          </p>
        </td>
        <td>
          <dropdown
            :options="hasCards"
            :selected="{ name: sendData.HAS_MIGRATION_CARD }"
            placeholder="Наличие карты"
            v-on:updateOption="
              isUpdate = true;
              sendData.HAS_MIGRATION_CARD = $event.name;
              $forceUpdate();
            "
            :disabled="
              pageInfo.DISABLED != null &&
                pageInfo.DISABLED.indexOf('HAS_MIGRATION_CARD') != -1
            "
          ></dropdown>
        </td>
      </tr>
      <tr v-if="sendData.HAS_MIGRATION_CARD == 'Есть'">
        <td>
          <p class="necessary-bold">
            <span
              :class="
                sendData.MIGRATION_CARD_NO != null &&
                sendData.MIGRATION_CARD_NO.length > 0
                  ? 'valid-field'
                  : 'unvalid-field'
              "
              >➤</span
            >
            Номер миграционной карты
          </p>
        </td>
        <td>
          <input
            class="input-line"
            type="text"
            v-model="sendData.MIGRATION_CARD_NO"
            :onchanged="
              sendData.MIGRATION_CARD_NO != null &&
              sendData.MIGRATION_CARD_NO.length > 63
                ? (sendData.MIGRATION_CARD_NO = sendData.MIGRATION_CARD_NO.substr(
                    0,
                    63
                  ))
                : sendData.MIGRATION_CARD_NO
            "
            @input="isUpdate = true"
            :disabled="
              pageInfo.DISABLED != null &&
                pageInfo.DISABLED.indexOf('MIGRATION_CARD_NO') != -1
            "
          />
        </td>
      </tr>
      <tr v-if="sendData.HAS_MIGRATION_CARD == 'Есть'">
        <td>
          <p class="necessary-bold">
            <span
              :class="
                sendData.DATE_FROM != null &&
                sendData.DATE_FROM.length == 10 &&
                !unvalidDateFrom
                  ? 'valid-field'
                  : 'unvalid-field'
              "
              >➤</span
            >
            Дата начала срока пребывания в Российской Федерации
          </p>
        </td>
        <td>
          <input
            type="text"
            v-bind:class="
              sendData.unvalidDateFrom ? 'necessary-unvalid' : 'necessary-valid'
            "
            v-mask="'##.##.####'"
            v-model="sendData.DATE_FROM"
            placeholder="дд.мм.гггг"
            :onchanged="dateFromChanged()"
            @blur="checkDateTo()"
            @input="isUpdate = true"
            :disabled="
              pageInfo.DISABLED != null &&
                pageInfo.DISABLED.indexOf('DATE_FROM') != -1
            "
          />
          <p class="necessary-message" v-if="unvalidDateFrom">
            Введите корректную начала срока пребывания в Российской Федерации
          </p>
        </td>
      </tr>
      <tr v-if="sendData.HAS_MIGRATION_CARD == 'Есть'">
        <td>
          <p class="necessary-bold">
            <span
              :class="
                sendData.DATE_TO != null &&
                sendData.DATE_TO.length == 10 &&
                !unvalidDateTo
                  ? 'valid-field'
                  : 'unvalid-field'
              "
              >➤</span
            >
            Дата окончания срока пребывания в Российской Федерации
          </p>
        </td>
        <td>
          <input
            type="text"
            v-bind:class="
              sendData.unvalidDateTo ? 'necessary-unvalid' : 'necessary-valid'
            "
            v-mask="'##.##.####'"
            v-model="sendData.DATE_TO"
            placeholder="дд.мм.гггг"
            :onchanged="dateToChanged()"
            @blur="checkDateFrom()"
            @input="isUpdate = true"
            :disabled="
              pageInfo.DISABLED != null &&
                pageInfo.DISABLED.indexOf('DATE_TO') != -1
            "
          />
          <p class="necessary-message" v-if="unvalidDateTo">
            Введите корректную окончания срока пребывания в Российской Федерации
          </p>
        </td>
      </tr>
      <tr v-if="sendData.TAX_STATUS == 'Нерезидент'">
        <td>
          <p>
            Документ, подтверждающий право иностранного гражданина или лица без
            гражданства на пребывание (проживание) в Российской Федерации
          </p>
          <label>
            <input
              type="checkbox"
              v-model="hasDocNo"
              @click="
                sendData.FOREIGNMAN_DOCNO = '';
                isUpdate = true;
              "
              :disabled="
                pageInfo.DISABLED != null &&
                  pageInfo.DISABLED.indexOf('FOREIGNMAN_DOCNO') != -1
              "
            />
            Документ отсутствует
          </label>
        </td>
        <td>
          <input
            type="text"
            class="input-line"
            v-model="sendData.FOREIGNMAN_DOCNO"
            :disabled="
              hasDocNo ||
                (pageInfo.DISABLED != null &&
                  pageInfo.DISABLED.indexOf('FOREIGNMAN_DOCNO') != -1)
            "
            :onchanged="
              sendData.FOREIGNMAN_DOCNO != null &&
              sendData.FOREIGNMAN_DOCNO.length > 255
                ? (sendData.FOREIGNMAN_DOCNO = sendData.FOREIGNMAN_DOCNO.substr(
                    0,
                    255
                  ))
                : sendData.FOREIGNMAN_DOCNO
            "
            @input="isUpdate = true"
          />
        </td>
      </tr>
    </table>

    <div class="data-is-right-checkboxes">
      <label>
        <input
          type="checkbox"
          v-model="dataIsRight[0]"
          @click="
            dataIsRight = [dataIsRight[0], false];
            isUpdate = true;
            invalidData = '';
          "
          :disabled="
            pageInfo.DISABLED != null &&
              pageInfo.DISABLED.indexOf('COMPANY_DATA_VALID') != -1
          "
        />Данные верны
      </label>
      <label>
        <input
          type="checkbox"
          v-model="dataIsRight[1]"
          @click="
            isUpdate = true;
            dataIsRight = [false, dataIsRight[1]];
            invalidData = '';
          "
          :disabled="
            pageInfo.DISABLED != null &&
              pageInfo.DISABLED.indexOf('COMPANY_DATA_VALID') != -1
          "
        />Внести изменения
      </label>
    </div>
    <div v-if="dataIsRight[1]" class="invalid-data">
      <p class="necessary-bold">
        <span
          :class="
            invalidData != null && invalidData.length > 0
              ? 'valid-field'
              : 'unvalid-field'
          "
          >➤</span
        >
        Укажите строку, в которой указаны неверные данные и укажите верные
        данные
      </p>
      <textarea
        class="invalid-data-textarea"
        v-model="invalidData"
        @input="isUpdate = true"
        :disabled="
          pageInfo.DISABLED != null &&
            pageInfo.DISABLED.indexOf(
              'GENERAL_INFO_WITH_STATCODES_INVALID_DATA'
            ) != -1
        "
      ></textarea>
    </div>
  </div>
</template>

<script>
import { VMoney } from "v-money";
import mask from "./utils/my-mask.js";
import dropdown from "vue-dropdowns";
import dateConventer from "./utils/date-converter.js";
import fieldFormatter from "./utils/field-formatter.js";

export default {
  name: "IpInformation",
  props: {
    pageInfo: {},
    pageName: String,
    url: String,
  },
  components: {
    dropdown,
  },
  directives: { money: VMoney },
  data() {
    return {
      docTypes: [
        { name: "Паспорт гражданина РФ" },
        { name: "Загранпаспорт гражданина РФ" },
        { name: "Удостоверение личности военнослужащего РФ" },
        { name: "Паспорт иностранного гражданина" },
        { name: "Удостоверение беженца" },
        {
          name:
            "Свидетельство о предоставлении временного убежища на территории РФ",
        },
      ],
      taxesStatuses: [
        {
          name: "Резидент",
        },
        {
          name: "Нерезидент",
        },
      ],
      hasCards: [{ name: "Есть" }, { name: "Нет" }],
      haveEng: false,
      haveSite: false,
      noContent: true,
      unvalidEmail: false,
      unvalidAuxSite: false,
      unvalidSite: false,
      actualAddressLikeLegal: false,
      mailAddressLikeActual: false,
      unvalidBirthDate: false,
      unvalidDulDate: false,
      unvalidDateTo: false,
      unvalidDateFrom: false,
      unvalidAuxEmail: false,
      hasDocNo: false,
      invalidData: "",
      stuffCount: "",
      isUpdate: false,
      mailAddressLikeLegal: false,
      hasCode: false,
      ustavLike: [false, false],
      sendData: {
        POST_ADDRESS: "",
        EMAIL: "",
        AUX_EMAIL: "",
        FACT_ADDRESS: "",
        STUFF_COUNT: "",
        WEB_SITE: "",
        AUX_WEB_SITE: "",
        AUX_PHONE_NUMBER: "",
        AUX_PHONE_APPEND: "",
        DUL_NUMBER: "",
        DUL_SERIAL: "",
        DUL_DATE: "",
        DUL_ISSUER: "",
        PHONE_NUMBER: "",
        BIRTH_DATE: "",
        DUL_CODE: "",
        BIRTH_PLACE: "",
        CITIZENSHIP: "",
        MIGRATION_CARD_NO: "",
        REG_ADDRESS: "",
        DATE_FROM: "",
        DATE_TO: "",
        PHONE_APPEND: "",
      },
      dataIsRight: [false, false],
      issuerList: [],
      money: {
        decimal: ",",
        thousands: " ",
        prefix: "",
        suffix: "",
        precision: 0,
        masked: false,
      },
    };
  },
  methods: {
    formatDocNumber(field) {
      return fieldFormatter.formatDocNumber(field);
    },
    onChangeStuffCount() {
      if (this.stuffCount.length > 12)
        this.stuffCount = this.stuffCount.substr(0, 12);
    },
    validField(field) {
      return field == null || (field != null && field.length == 0);
    },
    checkDate(date) {
      return mask.date(date);
    },
    async getDulIssue(info) {
      try {
        info.DUL_ISSUER = "";
        if (!info.disableIssue) {
          info.disableIssue = true;
          let response = await fetch(this.url + "get_passp_issuer_by_code", {
            method: "POST",
            headers: {
              "Content-Type": "application/json;charset=utf-8",
            },
            body: JSON.stringify({
              DUL_CODE: info.DUL_CODE,
            }),
          });
          if (response.ok) {
            let data = await response.json();
            if (data.DUL_ISSUER != null) {
              switch (data.DUL_ISSUER.length) {
                case 0:
                  info.DUL_ISSUER = "Подразделение не найдено";
                  info.disableIssue = false;
                  break;
                case 1:
                  info.DUL_ISSUER = data.DUL_ISSUER[0];
                  info.disableIssue = true;
                  break;
                default:
                  this.issuerList = [];
                  info.disableIssue = true;
                  for (let i = 0; i < data.DUL_ISSUER.length; i++) {
                    this.issuerList.push({ name: data.DUL_ISSUER[i] });
                  }
                  break;
              }
            } else {
              info.DUL_ISSUER = "Подразделение не найдено";
              info.disableIssue = false;
            }
          } else throw new Error("Ошибка получения наименования подразделения");
        }
      } catch (e) {
        info.disableIssue = false;
        console.log(e);
      }
      this.$forceUpdate();
      this.validation();
    },
    birthDateChanged() {
      if (this.sendData.BIRTH_DATE != this.checkDate(this.sendData.BIRTH_DATE))
        this.sendData.BIRTH_DATE = this.checkDate(this.sendData.BIRTH_DATE);
      if (
        this.sendData.BIRTH_DATE != null &&
        this.sendData.BIRTH_DATE.length == 10
      )
        this.checkBirthDate();
      else this.unvalidBirthDate = false;
    },
    dulDateChanged() {
      if (this.sendData.DUL_DATE != this.checkDate(this.sendData.DUL_DATE))
        this.sendData.DUL_DATE = this.checkDate(this.sendData.DUL_DATE);
      if (this.sendData.DUL_DATE != null && this.sendData.DUL_DATE.length == 10)
        this.checkDulDate();
      else this.unvalidDulDate = false;
    },
    dateFromChanged() {
      if (this.sendData.DATE_FROM != this.checkDate(this.sendData.DATE_FROM))
        this.sendData.DATE_FROM = this.checkDate(this.sendData.DATE_FROM);
      if (
        this.sendData.DATE_FROM != null &&
        this.sendData.DATE_FROM.length == 10
      )
        this.checkDateFrom();
      else this.unvalidDateFrom = false;
    },
    dateToChanged() {
      if (this.sendData.DATE_TO != this.checkDate(this.sendData.DATE_TO))
        this.sendData.DATE_TO = this.checkDate(this.sendData.DATE_TO);
      if (this.sendData.DATE_TO != null && this.sendData.DATE_TO.length == 10)
        this.checkDateTo();
      else this.unvalidDateTo = false;
    },
    checkDateTo() {
      let date = new Date();
      let dulDate = this.sendData.DATE_TO;

      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();

      let dul_year = parseInt(dulDate.split(".")[2]);
      let dul_months = parseInt(dulDate.split(".")[1]);
      let dul_days = parseInt(dulDate.split(".")[0]);
      if (dulDate.length == 10) {
        this.unvalidDateTo = !(
          dul_year > year ||
          (dul_year == year && dul_months > month) ||
          (dul_year == year && dul_months == month && dul_days > day)
        );
      } else if (dulDate.length == 0) {
        this.unvalidDateTo = false;
      } else {
        this.unvalidDateTo = true;
      }
    },
    checkDateFrom() {
      let date = new Date();
      let birthDate = this.sendData.DATE_FROM;

      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();

      let dul_year = parseInt(birthDate.split(".")[2]);
      let dul_months = parseInt(birthDate.split(".")[1]);
      let dul_days = parseInt(birthDate.split(".")[0]);
      if (birthDate.length == 10) {
        this.unvalidDateFrom = !(
          dul_year < year ||
          (dul_year == year && dul_months < month) ||
          (dul_year == year && dul_months == month && dul_days < day)
        );
      } else if (birthDate.length == 0) {
        this.unvalidDateFrom = false;
      } else {
        this.unvalidDateFrom = true;
      }
    },
    checkBirthDate() {
      let date = new Date();
      let birthDate = this.sendData.BIRTH_DATE;

      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();

      let dul_year = parseInt(birthDate.split(".")[2]);
      let dul_months = parseInt(birthDate.split(".")[1]);
      let dul_days = parseInt(birthDate.split(".")[0]);
      if (birthDate.length == 10) {
        this.unvalidBirthDate =
          year - dul_year < 14 ||
          (year - dul_year == 14 && dul_months > month) ||
          (year - dul_year == 14 && dul_months == month && dul_days > day);
      } else if (birthDate.length == 0) {
        this.unvalidBirthDate = false;
      } else {
        this.unvalidBirthDate = true;
      }
    },
    checkDulDate() {
      let date = new Date();
      let dulDate = this.sendData.DUL_DATE;

      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();

      let dul_year = parseInt(dulDate.split(".")[2]);
      let dul_months = parseInt(dulDate.split(".")[1]);
      let dul_days = parseInt(dulDate.split(".")[0]);
      if (dulDate.length == 10) {
        this.unvalidDulDate = !(
          dul_year < year ||
          (dul_year == year && dul_months < month) ||
          (dul_year == year && dul_months == month && dul_days < day)
        );
      } else if (dulDate.length == 0) {
        this.unvalidDulDate = false;
      } else {
        this.unvalidDulDate = true;
      }
    },
    validation() {
      var msg = "";
      if (this.validField(this.sendData.REG_ADDRESS))
        msg +=
          msg.length == 0
            ? "Необходимо заполнить поля:<br>• Адрес места жительства<br>"
            : "• Адрес места жительства<br>";
      if (this.validField(this.sendData.FACT_ADDRESS))
        msg +=
          msg.length == 0
            ? "Необходимо заполнить поля:<br>• Адрес места пребывания<br>"
            : "• Адрес места пребывания<br>";
      if (this.validField(this.sendData.POST_ADDRESS))
        msg +=
          msg.length == 0
            ? "Необходимо заполнить поля:<br>• Почтовый адрес<br>"
            : "• Почтовый адрес<br>";
      if (
        this.sendData.DUL_DATE == null ||
        this.sendData.DUL_DATE.length != 10 ||
        this.unvalidDulDate
      )
        msg +=
          msg.length == 0
            ? "Необходимо заполнить поля:<br>• Дата выдачи документа<br>"
            : "• Дата выдачи документа<br>";
      if (this.validField(this.sendData.DUL_NUMBER))
        msg +=
          msg.length == 0
            ? "Необходимо заполнить поля:<br>• Номер документа<br>"
            : "• Номер документа<br>";
      if (this.validField(this.sendData.DUL_SERIAL))
        msg +=
          msg.length == 0
            ? "Необходимо заполнить поля:<br>• Серия документа<br>"
            : "• Серия документа<br>";
      if (
        this.validField(this.sendData.DUL_ISSUER) ||
        this.sendData.DUL_ISSUER == "Подразделение не найдено"
      )
        msg +=
          msg.length == 0
            ? "Необходимо заполнить поля:<br>• Наименование органа, выдавшего документ<br>"
            : "• Наименование органа, выдавшего документ<br>";
      if (this.validField(this.sendData.DUL_CODE) && !this.hasCode)
        msg +=
          msg.length == 0
            ? "Необходимо заполнить поля:<br>• Код подразделения<br>"
            : "• Код подразделения<br>";
      if (this.validField(this.sendData.BIRTH_PLACE))
        msg +=
          msg.length == 0
            ? "Необходимо заполнить поля:<br>• Место рождения<br>"
            : "• Место рождения<br>";
      if (
        this.sendData.BIRTH_DATE == null ||
        this.sendData.BIRTH_DATE.length != 10 ||
        this.unvalidBirthDate
      )
        msg +=
          msg.length == 0
            ? "Необходимо заполнить поля:<br>• Дата рождения<br>"
            : "• Дата рождения<br>";
      if (this.validField(this.sendData.CITIZENSHIP))
        msg +=
          msg.length == 0
            ? "Необходимо заполнить поля:<br>• Гражданство<br>"
            : "• Гражданство<br>";
      if (this.sendData.TAX_STATUS == null)
        msg +=
          msg.length == 0
            ? "Необходимо заполнить поля:<br>• Налоговый статус<br>"
            : "• Налоговый статус<br>";
      if (this.sendData.DUL_DOCTYPE == null)
        msg +=
          msg.length == 0
            ? "Необходимо заполнить поля:<br>• Тип документа, удостоверяющего личность<br>"
            : "• Тип документа, удостоверяющего личность<br>";
      if (
        this.sendData.TAX_STATUS == "Нерезидент" &&
        this.sendData.HAS_MIGRATION_CARD == null
      )
        msg +=
          msg.length == 0
            ? "Необходимо заполнить поля:<br>•  Наличие миграционной карты<br>"
            : "• Наличие миграционной карты<br>";
      if (this.sendData.HAS_MIGRATION_CARD == "Есть") {
        if (this.validField(this.sendData.MIGRATION_CARD_NO))
          msg +=
            msg.length == 0
              ? "Необходимо заполнить поля:<br>• Номер миграционной карты<br>"
              : "• Номер миграционной карты<br>";
        if (
          this.sendData.DATE_FROM == null ||
          this.sendData.DATE_FROM.length != 10 ||
          this.unvalidDateFrom
        )
          msg +=
            msg.length == 0
              ? "Необходимо заполнить поля:<br>•  Дата начала срока пребывания в Российской Федерации<br>"
              : "•  Дата начала срока пребывания в Российской Федерации<br>";
        if (
          this.sendData.DATE_TO == null ||
          this.sendData.DATE_TO.length == 0 ||
          this.unvalidDateTo
        )
          msg +=
            msg.length == 0
              ? "Необходимо заполнить поля:<br>•  Дата окончания срока пребывания в Российской Федерации<br>"
              : "•  Дата окончания срока пребывания в Российской Федерации<br>";
      }
      if (
        (this.validField(this.sendData.WEB_SITE) && !this.haveSite) ||
        this.unvalidSite
      )
        msg +=
          msg.length == 0
            ? "Необходимо заполнить поля:<br>• Адрес сайта<br>"
            : "• Адрес сайта<br>";
      if (this.validField(this.sendData.EMAIL) || this.unvalidEmail)
        msg +=
          msg.length == 0
            ? "Необходимо заполнить поля:<br>• Адрес электронной почты<br>"
            : "• Адрес электронной почты<br>";
      if (this.sendData.PHONE_NUMBER.length != 18)
        msg +=
          msg.length == 0
            ? "Необходимо заполнить поля:<br>• Номер телефона<br>"
            : "• Номер телефона<br>";
      if (this.dataIsRight[1] && this.validField(this.invalidData))
        msg +=
          msg.length == 0
            ? "Необходимо заполнить поля:<br>• Укажите строку, в которой указаны неверные данные и укажите верные данные<br>"
            : "• Укажите строку, в которой указаны неверные данные и укажите верные данные<br>";
      if (this.unvalidEmai)
        msg += "Корректно введите адрес электронной почты<br>";
      if (!(this.dataIsRight[0] || this.dataIsRight[1]))
        msg += "Подтвердите корректность данных, заполненных автоматически";
      this.$emit("enableButtons", true, msg);
      if (msg.length == 0) {
        var sendArray = JSON.parse(JSON.stringify(this.sendData));
        sendArray.STUFF_COUNT = parseInt(this.stuffCount.split(" ").join(""));
        sendArray.COMPANY_DATA_VALID = this.dataIsRight[0];
        if (sendArray.COMPANY_DATA_VALID)
          delete sendArray.GENERAL_INFO_WITH_STATCODES_INVALID_DATA;
        else
          sendArray.GENERAL_INFO_WITH_STATCODES_INVALID_DATA = this.invalidData;
        sendArray.TAX_STATUS = this.sendData.TAX_STATUS == "Резидент";
        if (!sendArray.TAX_STATUS)
          sendArray.HAS_MIGRATION_CARD = sendArray.HAS_MIGRATION_CARD == "Есть";
        else {
          delete sendArray.HAS_MIGRATION_CARD;
          delete sendArray.MIGRATION_CARD_NO;
          delete sendArray.FOREIGNMAN_DOCNO;
          delete sendArray.DATE_FROM;
          delete sendArray.DATE_TO;
        }
        this.$emit("changePageSendData", sendArray, false);
      }
    },
    siteChecked() {
      this.sendData.WEB_SITE = "";
      this.sendData.AUX_WEB_SITE = "";
      this.unvalidAuxSite = false;
      this.unvalidSite = false;
    },
    checkSite() {
      this.unvalidSite = mask.siteCheck(this.sendData.WEB_SITE);
    },
    checkAuxSite() {
      this.unvalidAuxSite = mask.siteCheck(this.sendData.AUX_WEB_SITE);
    },
    checkEmail() {
      this.unvalidEmail = mask.emailCheck(this.sendData.EMAIL);
    },
    checkAuxEmail() {
      this.unvalidAuxEmail = mask.emailCheck(this.sendData.AUX_EMAIL);
    },
    fillInfo() {
      if (this.pageInfo.FACT_ADDRESS != null) {
        this.sendData.FACT_ADDRESS = this.pageInfo.FACT_ADDRESS;
      }
      if (this.pageInfo.REG_ADDRESS != null) {
        this.sendData.REG_ADDRESS = this.pageInfo.REG_ADDRESS;
      }
      if (this.pageInfo.TAX_STATUS != null) {
        this.sendData.TAX_STATUS = this.pageInfo.TAX_STATUS
          ? "Резидент"
          : "Нерезидент";
      }
      if (this.pageInfo.HAS_MIGRATION_CARD != null) {
        this.sendData.HAS_MIGRATION_CARD = this.pageInfo.HAS_MIGRATION_CARD
          ? "Есть"
          : "Нет";
      }
      if (this.pageInfo.DATE_FROM != null) {
        this.sendData.DATE_FROM = dateConventer.fromServerConvert(
          this.pageInfo.DATE_FROM
        );
      }
      if (this.pageInfo.DATE_TO != null) {
        this.sendData.DATE_TO = dateConventer.fromServerConvert(
          this.pageInfo.DATE_TO
        );
      }
      if (this.pageInfo.DUL_DOCTYPE != null) {
        this.sendData.DUL_DOCTYPE = this.pageInfo.DUL_DOCTYPE;
      }
      if (this.pageInfo.DUL_NUMBER != null) {
        this.sendData.DUL_NUMBER = this.pageInfo.DUL_NUMBER;
      }
      if (this.pageInfo.DUL_SERIAL != null) {
        this.sendData.DUL_SERIAL = this.pageInfo.DUL_SERIAL;
      }
      if (this.pageInfo.DUL_DATE != null) {
        this.sendData.DUL_DATE = dateConventer.fromServerConvert(
          this.pageInfo.DUL_DATE
        );
        if (
          this.pageInfo.DUL_CODE == null ||
          this.pageInfo.DUL_CODE.length == 0
        ) {
          this.hasCode = true;
        }
      }
      if (this.pageInfo.DUL_ISSUER != null) {
        this.sendData.DUL_ISSUER = this.pageInfo.DUL_ISSUER;
      }
      if (this.pageInfo.DUL_CODE != null) {
        this.sendData.DUL_CODE = this.pageInfo.DUL_CODE;
      }
      if (this.pageInfo.BIRTH_DATE != null) {
        this.sendData.BIRTH_DATE = dateConventer.fromServerConvert(
          this.pageInfo.BIRTH_DATE
        );
      }
      if (this.pageInfo.BIRTH_PLACE != null) {
        this.sendData.BIRTH_PLACE = this.pageInfo.BIRTH_PLACE;
      }
      if (this.pageInfo.CITIZENSHIP != null) {
        this.sendData.CITIZENSHIP = this.pageInfo.CITIZENSHIP;
      }
      if (this.pageInfo.POST_ADDRESS != null) {
        {
          if (this.pageInfo.WEB_SITE != null) {
            {
              this.sendData.WEB_SITE = this.pageInfo.WEB_SITE;
              if (this.pageInfo.AUX_WEB_SITE != null) {
                this.sendData.AUX_WEB_SITE = this.pageInfo.AUX_WEB_SITE;
              }
            }
          } else {
            this.haveSite = true;
          }
          this.sendData.POST_ADDRESS = this.pageInfo.POST_ADDRESS;
        }
      }
      if (this.pageInfo.EMAIL != null) {
        this.sendData.EMAIL = this.pageInfo.EMAIL;
      }
      if (this.pageInfo.AUX_EMAIL != null) {
        this.sendData.AUX_EMAIL = this.pageInfo.AUX_EMAIL;
      }
      if (this.pageInfo.AUX_PHONE_NUMBER != null) {
        this.sendData.AUX_PHONE_NUMBER = this.pageInfo.AUX_PHONE_NUMBER;
      }
      if (this.pageInfo.AUX_PHONE_APPEND != null) {
        this.sendData.AUX_PHONE_APPEND = this.pageInfo.AUX_PHONE_APPEND;
      }
      if (this.pageInfo.COMPANY_DATA_VALID != null) {
        this.dataIsRight = [
          this.pageInfo.COMPANY_DATA_VALID,
          !this.pageInfo.COMPANY_DATA_VALID,
        ];
      }
      if (this.pageInfo.PHONE_APPEND != null) {
        this.sendData.PHONE_APPEND = this.pageInfo.PHONE_APPEND;
      }
      if (this.pageInfo.PHONE_NUMBER != null) {
        this.sendData.PHONE_NUMBER = this.pageInfo.PHONE_NUMBER;
      }
      if (this.pageInfo.GENERAL_INFO_WITH_STATCODES_INVALID_DATA != null) {
        this.invalidData = this.pageInfo.GENERAL_INFO_WITH_STATCODES_INVALID_DATA;
      }
      if (this.pageInfo.STUFF_COUNT != null) {
        this.stuffCount = String(this.pageInfo.STUFF_COUNT);
      }
    },
    checkUpdateStuff() {
      return (
        parseInt(this.stuffCount.split(" ").join("")) ==
          this.pageInfo.STUFF_COUNT &&
        this.pageInfo.PHONE_NUMBER == this.sendData.PHONE_NUMBER
      );
    },
  },
  async created() {
    this.sendData.INN = this.pageInfo.INN;

    this.sendData.UPDATE_DATE = this.pageInfo.UPDATE_DATE;
    this.sendData.ID = this.pageInfo.ID;
    this.fillInfo();
    this.validation();
  },
  updated() {
    this.validation();
    if (this.isUpdate || !this.checkUpdateStuff()) this.$emit("updated");
  },
};
</script>

<style scoped>
.main-wrapper {
  text-align: left;
}
.left-column {
  width: 25%;
  vertical-align: top;
}
td {
  padding-left: 10px;
}
.input-line,
.telephone-lines {
  border: none;
  border-bottom: 1px solid #cccccc;
  width: 100%;
  position: relative;
}
.input-line:focus,
.necessary-valid:focus,
.necessary-unvalid:focus,
.telephone-lines:focus {
  border-bottom: 1px solid #06569b;
  outline: none;
}
.checkboxes {
  display: flex;
  flex-direction: column;
}
.necessary {
  color: red;
}
.necessary-message {
  color: red;
  font-size: 12px;
}
.necessary-unvalid {
  border: none;
  border-bottom: 1px solid red;
  width: 100%;
}
.necessary-valid {
  border: none;
  width: 100%;
  border-bottom: 1px solid #cccccc;
}
.data-is-right-checkboxes {
  text-align: center;
  padding: 5px 0px;
}
.telephone-lines {
  width: auto;
  margin-right: 5px;
}
</style>
